import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e912ad2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "empty-cart"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Você não possui produtos no carrinho. Volte ao cardápio do estabelecimento para adicionar alguns :) ", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "item-header" }
const _hoisted_8 = {
  key: 0,
  class: "quantity"
}
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "detail" }
const _hoisted_12 = { class: "options" }
const _hoisted_13 = {
  key: 0,
  class: "quantity-suboptions"
}
const _hoisted_14 = { class: "product-note" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Observação", -1))
const _hoisted_17 = { class: "value-subinfo" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Subtotal", -1))
const _hoisted_19 = { class: "value-subinfo" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Taxa de entrega", -1))
const _hoisted_21 = {
  key: 0,
  class: "value-subinfo"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Desconto saldo", -1))
const _hoisted_23 = { class: "coupon-value" }
const _hoisted_24 = {
  key: 1,
  class: "value-subinfo"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Desconto cupom", -1))
const _hoisted_26 = { class: "value-subinfo" }
const _hoisted_27 = { class: "value-total" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Total", -1))
const _hoisted_29 = {
  key: 2,
  class: "cashback-value"
}
const _hoisted_30 = { class: "notes" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Alguma observação na entrega?", -1))
const _hoisted_32 = { class: "coupon-content" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Cupom de desconto", -1))
const _hoisted_34 = { class: "coupon-message" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Esta loja não aceita cupom ou usar o saldo da carteira.", -1))
const _hoisted_36 = { class: "balance-wallet-content" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Saldo da carteira", -1))
const _hoisted_38 = { class: "balance-message" }
const _hoisted_39 = { class: "payment-content" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Pagamento", -1))
const _hoisted_41 = {
  key: 0,
  class: "payment-message"
}
const _hoisted_42 = {
  key: 1,
  class: "payment-message"
}
const _hoisted_43 = {
  key: 2,
  class: "payment-message"
}
const _hoisted_44 = {
  key: 3,
  class: "payment-submessage"
}
const _hoisted_45 = {
  key: 4,
  class: "payment-submessage"
}
const _hoisted_46 = { class: "delivery-content" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Entrega", -1))
const _hoisted_48 = {
  key: 0,
  class: "delivery-message"
}
const _hoisted_49 = {
  key: 1,
  class: "delivery-message"
}
const _hoisted_50 = {
  key: 2,
  class: "delivery-message"
}
const _hoisted_51 = { class: "invoice-content" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "CPF na nota", -1))
const _hoisted_53 = {
  key: 0,
  class: "invoice-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_with_balance = _resolveComponent("header-with-balance")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_header_with_balance, {
            class: "balance-header",
            title: "Carrinho",
            "has-go-back": true
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              ($options.productSelected.products.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode(_component_ion_button, {
                      shape: "round",
                      fill: "outline",
                      color: "primary",
                      onClick: $options.emptyCart
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ir para cardápio")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_ion_card, { class: "products" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.productSelected.products, (product, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: product.id,
                                class: "item",
                                onClick: ($event: any) => ($options.changeProduct(index, product))
                              }, [
                                _createElementVNode("div", _hoisted_7, [
                                  (product.quantity > 1)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(product.quantity) + "x ", 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("p", _hoisted_9, _toDisplayString(product.name), 1),
                                  _createElementVNode("p", _hoisted_10, _toDisplayString($setup.moneyMask(product.price * product.quantity)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.options, (options) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: options.id
                                      }, [
                                        _createElementVNode("p", null, _toDisplayString(options.name), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.suboptions, (suboptions) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: suboptions.id,
                                            class: "suboption-name"
                                          }, [
                                            _createElementVNode("p", null, [
                                              (suboptions.quantity > 1)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(suboptions.quantity) + "x ", 1))
                                                : _createCommentVNode("", true),
                                              _createTextVNode(_toDisplayString(suboptions.name), 1)
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    }), 128)),
                                    _createElementVNode("div", _hoisted_14, [
                                      (product.note)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _hoisted_16,
                                            _createElementVNode("span", null, "\"" + _toDisplayString(product.note) + "\"", 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createVNode(_component_ion_button, {
                                    class: "alter",
                                    fill: "outline"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Alterar ")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ], 8, _hoisted_6))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card, { class: "value-totals" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_17, [
                              _hoisted_18,
                              _createElementVNode("p", null, _toDisplayString($setup.moneyMask($options.productSelected.price)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("p", null, _toDisplayString($setup.moneyMask($options.productSelected.deliveryFee)), 1)
                            ]),
                            (_ctx.walletUsed != 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _hoisted_22,
                                  _createElementVNode("p", _hoisted_23, _toDisplayString($setup.moneyMask(_ctx.walletUsed)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            ($options.productSelected?.coupon?.discount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _hoisted_25,
                                  _createElementVNode("p", _hoisted_26, _toDisplayString($setup.moneyMask($options.productSelected.coupon.discount)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _createElementVNode("p", null, _toDisplayString($setup.moneyMask($options.getTotal)), 1)
                            ]),
                            ($options.cashbackGiven > 0.0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_29, " Ganhe " + _toDisplayString($setup.moneyMask($options.cashbackGiven)) + " de volta ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_ion_textarea, {
                        modelValue: _ctx.deliveryNote,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.deliveryNote) = $event)),
                        type: "text",
                        "auto-grow": true,
                        maxlength: "400",
                        placeholder: "Ex: Buzine na porta quando chegar",
                        autocomplete: "off"
                      }, null, 8, ["modelValue"])
                    ]),
                    ($options.productSelected.allowCouponOrCashback)
                      ? (_openBlock(), _createBlock(_component_ion_card, {
                          key: 0,
                          class: "coupon"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_32, [
                                  _createVNode(_component_ion_icon, {
                                    size: "large",
                                    icon: $setup.ticketOutline
                                  }, null, 8, ["icon"]),
                                  _createElementVNode("div", null, [
                                    _hoisted_33,
                                    _createElementVNode("span", _hoisted_34, _toDisplayString($options.couponsMessage), 1)
                                  ])
                                ]),
                                ($options.productSelected?.coupon?.name)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 0,
                                      fill: "outline",
                                      class: "alter",
                                      onClick: $options.removeCoupon
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Remover ")
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (!$options.productSelected?.coupon?.name && _ctx.walletUsed == 0)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 1,
                                      fill: "outline",
                                      class: "alter",
                                      onClick: $options.openModalCoupom
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Adicionar")
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (_ctx.walletUsed > 0)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 2,
                                      disabled: "",
                                      fill: "outline",
                                      class: "alter",
                                      onClick: $options.openModalCoupom
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Adicionar")
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_ion_card, {
                          key: 1,
                          class: "not-allow-coupon"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _hoisted_35
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                    ($options.balance && $options.productSelected.allowCouponOrCashback)
                      ? (_openBlock(), _createBlock(_component_ion_card, {
                          key: 2,
                          class: "balance-wallet"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_36, [
                                  _hoisted_37,
                                  _createElementVNode("span", _hoisted_38, [
                                    _createTextVNode(" Usar " + _toDisplayString($options.balance > $options.productSelected.price
                        ? $setup.moneyMask($options.productSelected.price)
                        : $setup.moneyMask($options.balance)) + " ", 1),
                                    _createElementVNode("span", null, "(de " + _toDisplayString($setup.moneyMask($options.balance)) + ")", 1),
                                    _createTextVNode(" da carteira ")
                                  ])
                                ]),
                                (!$options.productSelected?.coupon?.name)
                                  ? (_openBlock(), _createBlock(_component_ion_toggle, {
                                      key: 0,
                                      modelValue: _ctx.walletUsed,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.walletUsed) = $event)),
                                      onIonChange: _cache[2] || (_cache[2] = ($event: any) => ($options.useCashback($event.detail.checked)))
                                    }, null, 8, ["modelValue"]))
                                  : (_openBlock(), _createBlock(_component_ion_toggle, {
                                      key: 1,
                                      modelValue: _ctx.walletUsed,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.walletUsed) = $event)),
                                      disabled: "",
                                      onIonChange: _cache[4] || (_cache[4] = ($event: any) => ($options.useCashback($event.detail.checked)))
                                    }, null, 8, ["modelValue"]))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_card, { class: "payment" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_39, [
                              _hoisted_40,
                              ($options.getTotal <= 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_41, " Não é necessário pagamento para esse pedido "))
                                : (!$options.paymentMethodComputed.name)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, " Escolher forma de pagamento "))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString($options.paymentMethodComputed.name), 1)),
                              ($options.moneyValue)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_44, " Troco para " + _toDisplayString($setup.moneyMask($options.moneyValue)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString($options.paymentMethodComputed.description), 1))
                            ]),
                            (!$options.paymentMethodComputed.name && $options.getTotal > 0)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  fill: "outline",
                                  class: "alter",
                                  onClick: $options.openPaymentMethodsModal
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Adicionar")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : ($options.getTotal > 0)
                                ? (_openBlock(), _createBlock(_component_ion_button, {
                                    key: 1,
                                    fill: "outline",
                                    class: "alter",
                                    onClick: $options.openPaymentMethodsModal
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Alterar")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card, { class: "delivery" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_46, [
                              _hoisted_47,
                              (_ctx.isWithdraw)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_48, " Você irá retirar no estabelecimento "))
                                : _createCommentVNode("", true),
                              (!$options.addressStreetNameComputed && !_ctx.isWithdraw)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_49, " Escolher endereço "))
                                : _createCommentVNode("", true),
                              ($options.addressStreetNameComputed && !_ctx.isWithdraw)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString($options.addressStreetNameComputed) + ", " + _toDisplayString($options.addressNumberComputed), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (!$options.addressStreetNameComputed && !_ctx.isWithdraw)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  fill: "outline",
                                  class: "alter",
                                  onClick: $options.openDeliveryAddressModal
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Adicionar")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 1,
                                  fill: "outline",
                                  class: "alter",
                                  onClick: $options.openDeliveryAddressModal
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Alterar")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card, { class: "invoice" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_51, [
                              _hoisted_52,
                              (_ctx.taxpayerNumber)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.taxpayerNumber), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_ion_button, {
                              fill: "outline",
                              class: "alter",
                              onClick: $options.openDataInvoiceModal
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Adicionar")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              ($options.productSelected?.products?.length)
                ? (_openBlock(), _createBlock(_component_the_button, {
                    key: 0,
                    name: $options.titleButton,
                    onClick: $options.onConfirm
                  }, null, 8, ["name", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}